@if (driver().driverCard; as driverCard) {
  <section>
    <app-modal-documents-heading
      heading="labels.driverCard"
      [scans]="driverCard.scans"
    ></app-modal-documents-heading>

    <onyx-information-list>
      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="driverCard.expirationDate"
        [size]="size()"
      ></app-modal-date-row>

      <onyx-information-row label="labels.number" [size]="size()">
        {{ driverCard.number }}
      </onyx-information-row>

      <onyx-information-row label="labels.issuingCountry" [size]="size()">
        <app-country-cell
          [countryCode]="driverCard.issuingCountry"
        ></app-country-cell>
      </onyx-information-row>
    </onyx-information-list>
  </section>
}

<section>
  @let driverLicense = driver().driversLicenseAndProfessionalQualifications;
  <app-modal-documents-heading
    heading="labels.driverLicense"
    [scans]="driverLicense.scans"
  ></app-modal-documents-heading>

  <onyx-information-list>
    @for (category of driverLicense.categories; track category) {
      <onyx-information-row
        [label]="`${DictionaryCode.DRIVERS_LICENSE_CATEGORY}.${category.category}`"
        [size]="size()"
      >
        @if (category.expirationDate.date) {
          {{ 'labels.to' | translate | lowercase }}
          {{ category.expirationDate.date | onyxDate: 'date-dot' }}
        } @else if (category.expirationDate.indefinite) {
          {{ 'labels.indefinite' | translate }}
        }
      </onyx-information-row>
    }

    @if (driverLicense.professionalQualificationsExpirationDate) {
      <app-modal-date-row
        label="labels.professionalQualifications"
        [expirationDate]="
          driverLicense.professionalQualificationsExpirationDate
        "
        [size]="size()"
      ></app-modal-date-row>
    }

    <onyx-information-row label="labels.driversLicenseNumber" [size]="size()">
      {{ driverLicense.driversLicenseNumber }}
    </onyx-information-row>

    @if (driverLicense.driversLicenseIssuingCountry; as issuingCountry) {
      <onyx-information-row label="labels.issuingCountry" [size]="size()">
        <app-country-cell [countryCode]="issuingCountry"></app-country-cell>
      </onyx-information-row>
    }
  </onyx-information-list>
</section>

@if (driver().identityDocuments.passport; as passport) {
  <section>
    <app-modal-documents-heading
      heading="labels.passport"
      [scans]="passport.scans"
    ></app-modal-documents-heading>

    <onyx-information-list>
      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="passport.expirationDate"
        [size]="size()"
      ></app-modal-date-row>

      @if (passport.number; as number) {
        <onyx-information-row label="labels.number" [size]="size()">
          {{ number }}
        </onyx-information-row>
      }

      <onyx-information-row label="labels.issuingCountry" [size]="size()">
        <app-country-cell
          [countryCode]="passport.issuingCountry"
        ></app-country-cell>
      </onyx-information-row>
    </onyx-information-list>
  </section>
}

@if (driver().identityDocuments.identityDocument; as identityDocument) {
  <section>
    <app-modal-documents-heading
      heading="labels.identityDocument"
      [scans]="identityDocument.scans"
    ></app-modal-documents-heading>

    <onyx-information-list>
      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="identityDocument.expirationDate"
        [size]="size()"
      ></app-modal-date-row>

      @if (identityDocument.number; as number) {
        <onyx-information-row label="labels.number" [size]="size()">
          {{ number }}
        </onyx-information-row>
      }

      <onyx-information-row label="labels.issuingCountry" [size]="size()">
        <app-country-cell
          [countryCode]="identityDocument.issuingCountry"
        ></app-country-cell>
      </onyx-information-row>
    </onyx-information-list>
  </section>
}

<section>
  @let clearCriminalRecordCertificate = driver().clearCriminalRecordCertificate;
  <app-modal-documents-heading
    heading="labels.clearCriminalRecordCertificate"
    [scans]="clearCriminalRecordCertificate.scans"
  ></app-modal-documents-heading>

  <onyx-information-list>
    <onyx-information-row label="labels.issueDate" [size]="size()">
      {{ clearCriminalRecordCertificate.issuingDate | onyxDate: 'date-dot' }}
    </onyx-information-row>
  </onyx-information-list>
</section>

<section>
  @let employment = driver().employmentConditions;
  <app-modal-documents-heading
    [heading]="`${DictionaryCode.CONTRACT_TYPE}.${employment.contractType}`"
    [scans]="employment.scans"
  ></app-modal-documents-heading>

  <onyx-information-list>
    <onyx-information-row label="labels.driverSettlementMethod" [size]="size()">
      {{
        `${DictionaryCode.DRIVER_SETTLEMENT_METHOD}.${employment.settlementMethod}`
          | translate
      }}
    </onyx-information-row>

    @if (employment.dailyRate) {
      <onyx-information-row label="labels.rate" [size]="size()">
        <app-amount-cell [amount]="employment.dailyRate"></app-amount-cell>
      </onyx-information-row>
    } @else if (employment.mileageRate) {
      <onyx-information-row
        [label]="'labels.mileageRate' | translate"
        [size]="size()"
      >
        <app-amount-cell [amount]="employment.mileageRate"></app-amount-cell>
      </onyx-information-row>
    } @else if (employment.baseRate && employment.freightPercentage) {
      <onyx-information-row
        [label]="'labels.baseRate' | translate"
        [size]="size()"
      >
        <app-amount-cell [amount]="employment.baseRate"></app-amount-cell>
      </onyx-information-row>

      <onyx-information-row
        [label]="'labels.freightPercentage' | translate"
        [size]="size()"
      >
        {{ employment.freightPercentage }}%
      </onyx-information-row>
    }

    @if (employment.contractType === ContractType.B2B) {
      <onyx-information-row label="labels.vatId" [size]="size()">
        {{ employment.nipNumber }}
      </onyx-information-row>

      <onyx-information-row
        [label]="'labels.company' | translate"
        [size]="size()"
      >
        {{ employment.companyName }}
      </onyx-information-row>
    }

    <onyx-information-row label="labels.range" [size]="size()">
      @let from = employment.contractTerm.from;
      @let to = employment.contractTerm.to;

      @if (from && to) {
        {{ from | onyxDate: 'date-dot' : { endDate: to } }}
      } @else {
        -
      }
    </onyx-information-row>
  </onyx-information-list>
</section>

@for (visa of driver().visas; track visa) {
  <section>
    <app-modal-documents-heading
      [heading]="`${DictionaryCode.COUNTRY}.${visa.country}`"
      subheading="labels.visa"
      [scans]="visa.scans"
    ></app-modal-documents-heading>

    <app-modal-date-row
      label="labels.expirationDate"
      [expirationDate]="visa.expirationDate"
      [size]="size()"
    ></app-modal-date-row>
  </section>
}

@for (permission of driver().permissions; track permission) {
  <section>
    <app-modal-documents-heading
      [heading]="permission.type.names | onyxLanguage"
      [scans]="permission.scans"
    ></app-modal-documents-heading>

    @if (permission.expirationDate) {
      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="permission.expirationDate"
        [size]="size()"
      ></app-modal-date-row>
    }
  </section>
}
